import { LanguageToggle as LanguageToggleFromArckit } from '@arckit/ui'
import { Col, Row, Section } from 'components/grid'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function LanguageToggle({ ...props }) {
	const { language, setLanguage } = useContext(CoreAdoptionContext)
	return (
		<Section id={formatSectionId(props)} className="scroll-mt-14">
			<Row>
				<Col>
					<LanguageToggleFromArckit language={language} onClickEnglish={() => setLanguage('english')} onClickSpanish={() => setLanguage('spanish')} />
				</Col>
			</Row>
		</Section>
	)
}
